import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useAppSelector } from "@store/store-helper";
import { companyMembersByRoleSelector, companyMembersSelector, fetchingMembersFlagsSelector } from "@store/members/members-selector";
import { InfoBar } from "@components/common/info-bar/info-bar";
import { InfoBarCounts } from "@components/common/info-bar/info-bar-counts";
import { useMediaQueryList } from "@hooks/use-media-query";
import { InviteMemberToCompany } from "@pages/members/invite-member-to-company";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";

/**
 * Shows the main details for members
 */
export function MainMemberDetails() {
  const $ = _c(33);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const {
    isFetchingCompanyMembers
  } = useAppSelector(fetchingMembersFlagsSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = companyMembersByRoleSelector("COMPANY_EXECUTIVE");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const adminMembers = useAppSelector(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = companyMembersByRoleSelector("COMPANY_MANAGER");
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const groupManagerMembers = useAppSelector(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = companyMembersByRoleSelector("PROJECT_MANAGER");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const projectManagerMembers = useAppSelector(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = companyMembersByRoleSelector("COMPANY_VIEWER");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const viewerMembers = useAppSelector(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = companyMembersByRoleSelector("GROUP_VIEWER");
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const groupViewers = useAppSelector(t4);
  const companyMembers = useAppSelector(companyMembersSelector);
  const {
    canInviteUsersToCompany
  } = useHasUserValidRoleCompanyLevel();
  const totalUsersInWorkspace = companyMembers.length;
  if (isFetchingCompanyMembers) {
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <InfoBar isLoading={true} />;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    return t5;
  }
  let t5;
  if ($[6] !== totalUsersInWorkspace) {
    t5 = {
      label: "Total",
      content: totalUsersInWorkspace
    };
    $[6] = totalUsersInWorkspace;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== adminMembers.length) {
    t6 = {
      label: "Admins",
      value: adminMembers.length
    };
    $[8] = adminMembers.length;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== viewerMembers.length) {
    t7 = {
      label: "Viewers",
      value: viewerMembers.length
    };
    $[10] = viewerMembers.length;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== groupManagerMembers.length) {
    t8 = {
      label: "Group Managers",
      value: groupManagerMembers.length
    };
    $[12] = groupManagerMembers.length;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== groupViewers.length) {
    t9 = {
      label: "Group Viewers",
      value: groupViewers.length
    };
    $[14] = groupViewers.length;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== projectManagerMembers.length) {
    t10 = {
      label: "Project Managers",
      value: projectManagerMembers.length
    };
    $[16] = projectManagerMembers.length;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t11 = {
      label: "Roles",
      isFlexible: true,
      content: <InfoBarCounts counts={[t6, t7, t8, t9, t10]} />
    };
    $[18] = t10;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t5) {
    t12 = [t5, t11];
    $[24] = t11;
    $[25] = t5;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <InviteMemberToCompany />;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = !canInviteUsersToCompany || isScreenSmOrSmaller;
  let t15;
  if ($[28] !== t14) {
    t15 = {
      content: t13,
      isHidden: t14
    };
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t12 || $[31] !== t15) {
    t16 = <InfoBar items={t12} action={t15} />;
    $[30] = t12;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
}